import scrollTo from '../scroll/handle-scroll-to';

const scrollToTab = () => {
  $('.js-scroll-to-tab').on('click', function(event) {
    const $this = $(this);
    const $targetTab = $($this.attr('href'));
    const $header = $('.header');
    const headerHeight = $header.find('.header__body').outerHeight() + $header.find('.header__product-bar').outerHeight();

    if ($targetTab.length > 0) {
      $targetTab.addClass('is-current')
        .siblings()
        .removeClass('is-current');

      $targetTab.closest('.tabs')
        .find('.tabs__nav li')
        .eq($targetTab.index())
        .addClass('is-current')
        .siblings()
        .removeClass('is-current');
    }

    scrollTo($targetTab.closest('.tabs').offset().top - headerHeight);

    event.preventDefault();
  });
}

scrollToTab();
